import axios from 'axios';
  
export const SPRING_URL = 'https://aetherforgespringserver.onrender.com'; //'http://localhost:8080';
export const EXPRESS_URL = 'https://aetherforgeexpressserver.onrender.com/'; //'http://localhost:7070';
export const DOTNET_URL = 'https://aetherforgedotnetserver.onrender.com/'; //'http://localhost:5050';

export default axios.create({
    baseURL: SPRING_URL
});

export const axiosSpring = axios.create({
    baseURL: SPRING_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
